import { Injectable } from "@angular/core";

interface FullscreenElement extends HTMLElement {
  webkitRequestFullscreen?: () => Promise<void>;
  msRequestFullscreen?: () => Promise<void>;
}

interface FullscreenDocument extends Document {
  webkitExitFullscreen?: () => Promise<void>;
  msExitFullscreen?: () => Promise<void>;
}

/**
 * Service to manage fullscreen functionality for the kiosk app
 */
@Injectable({
  providedIn: "root",
})
export class FullscreenService {
  /**
   * Requests fullscreen mode for the document
   */
  public requestFullscreen(): void {
    try {
      const element = document.documentElement as FullscreenElement;
      if (element.requestFullscreen) {
        void element.requestFullscreen();
      } else if (element.webkitRequestFullscreen) {
        void element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        void element.msRequestFullscreen();
      }
    } catch (err) {
      console.error("Failed to enter fullscreen mode:", err);
    }
  }

  /**
   * Exits fullscreen mode
   */
  public exitFullscreen(): void {
    try {
      const doc = document as FullscreenDocument;
      if (document.fullscreenElement) {
        if (doc.exitFullscreen) {
          void doc.exitFullscreen();
        } else if (doc.webkitExitFullscreen) {
          void doc.webkitExitFullscreen();
        } else if (doc.msExitFullscreen) {
          void doc.msExitFullscreen();
        }
      }
    } catch (err) {
      console.error("Failed to exit fullscreen mode:", err);
    }
  }
}
